var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0C13.9835 0 18 4.01647 18 9C18 13.9835 13.9835 18 9 18C4.01647 18 0 13.9835 0 9C0 4.01647 4.01647 0 9 0ZM6.02478 3.64451C7.36369 3.64451 8.47937 4.6858 8.47937 6.02466C8.47937 7.36357 7.36369 8.47925 6.02478 8.47925C4.68588 8.47925 3.64463 7.36357 3.64463 6.02466C3.64463 4.68576 4.68592 3.64451 6.02478 3.64451ZM11.975 3.64451C13.3139 3.64451 14.3551 4.6858 14.3551 6.02466C14.3551 7.36357 13.3138 8.47925 11.975 8.47925C10.6361 8.47925 9.52039 7.36357 9.52039 6.02466C9.52039 4.68576 10.6361 3.64451 11.975 3.64451ZM6.02478 9.52019C7.36369 9.52019 8.47937 10.6359 8.47937 11.9748C8.47937 13.3137 7.36369 14.3549 6.02478 14.3549C4.68588 14.3549 3.64463 13.3136 3.64463 11.9748C3.64463 10.6359 4.68592 9.52019 6.02478 9.52019ZM11.975 9.52019C13.3139 9.52019 14.3551 10.6359 14.3551 11.9748C14.3551 13.3137 13.3138 14.3549 11.975 14.3549C10.6361 14.3549 9.52039 13.3136 9.52039 11.9748C9.52039 10.6359 10.6361 9.52019 11.975 9.52019Z",
    fill: "#49A6F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherActive);
export default __webpack_public_path__ + "static/media/otherActive.4a2f5a8d1cbb72c0cdab9da7254b33f9.svg";
export { ForwardRef as ReactComponent };